import LeftDoubleQuote from "@gaiaProfessionals/Icons/LeftDoubleQuote";
import RightDoubleQuote from "@gaiaProfessionals/Icons/RightDoubleQuote";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon, ButtonProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { useEmblaCarousel } from "embla-carousel/react";
import React from "react";
import { css } from "styled-components";

const enum fields {
    links = "links",
}

interface LinkModel {
    fields: {
        title: string;
        subTitle: string;
        imageUrl: string;
        altText: string;
        description: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: { [fields.links]: LinkModel[] };
}
type Props = OwnProps;

export interface MeetYourHerbsQuoteStyles {
    blogContainer?: InjectableCss;
    blogCardWithoutCarausal?: InjectableCss;
    blogCardWithCarausal?: InjectableCss;
    blogImage?: LazyImageProps;
    blogDesc?: InjectableCss;
    leftQuote?: TypographyProps;
    rightQuote?: TypographyProps;
    blogTitle?: TypographyProps;
    blogSubtitle?: TypographyProps;
    prevArrowContainer?: InjectableCss;
    prevArrowButton?: ButtonProps;
    nextArrowContainer?: InjectableCss;
    nextArrowButton?: ButtonProps;
    blogListWrapper?: InjectableCss;
    blogListWrapperContainer?: InjectableCss;
    blogListWrapperWithCarousal?: InjectableCss;
    blogListWrapperWithoutCarousal?: InjectableCss;
}

export const styles: MeetYourHerbsQuoteStyles = {
    blogContainer: {
        css: css`
            margin-bottom: 46px;
            position: relative;
            width: 100%;
        `,
    },
    blogCardWithCarausal: {
        css: css`
            background: #fff !important;
            padding: 70px 45px 30px;
            box-shadow: 0px 3px 18px #00000014;
            border-radius: 8px;
            text-align: center;
            position: relative;
            min-width: 70%;
            margin-left: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        min-width: 100%;
                        margin-left: 0px;
                    `,
                    css`
                        min-width: 100%;
                        margin-left: 0px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    blogCardWithoutCarausal: {
        css: css`
            background: #fff !important;
            padding: 70px 45px 30px;
            box-shadow: 0px 3px 18px #00000014;
            border-radius: 8px;
            text-align: center;
            position: relative;
            min-width: auto;
            &:last-child {
                margin-left: 10px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        min-width: 100%;
                        &:last-child {
                            margin-left: 0px;
                        }
                    `,
                    css`
                        min-width: 100%;
                        &:last-child {
                            margin-left: 0px;
                        }
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    blogImage: {
        css: css`
            width: 102px;
            height: 102px;
            border-radius: 50%;
            position: absolute;
            top: -51px;
            left: 43.5%;
            right: auto;
            img {
                height: 100%;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        left: 32%;
                    `,
                    css`
                        left: 32%;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    blogDesc: {
        css: css`
            font-style: italic;
            margin-bottom: 48px;
        `,
    },
    blogTitle: {
        variant: "h3",
        color: "primary",
        size: 20,
        css: css`
            margin-bottom: 7px;
            font-weight: unset;
            font-family: LibreBaskerville;
        `,
    },
    blogSubtitle: {},
    nextArrowContainer: {
        css: css`
            justify-content: flex-end;
            position: absolute;
            right: -15px;
            top: 56%;
            width: 40px;
            height: 40px;
            overflow: hidden;
            border-radius: 50%;
            border: 1px solid #e5e5e5;
            z-index: 2;
        `,
    },
    nextArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
            width: 100%;
            height: 100%;
            background: #fff;
            span {
                width: 30px;
                height: 30px;
                padding-left: 3px;
                top: 0 !important;
                > svg {
                    color: #d14124;
                    width: 25px;
                    height: 25px;
                }
            }
            &:hover {
                background: #d14124;
                svg {
                    color: #fff;
                }
            }
        `,
    },
    prevArrowContainer: {
        css: css`
            justify-content: flex-start;
            position: absolute;
            left: -15px;
            top: 56%;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: 1px solid #e5e5e5;
            overflow: hidden;
            z-index: 2;
        `,
    },
    prevArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
            width: 100%;
            height: 100%;
            background: #fff;
            span {
                width: 30px;
                height: 30px;
                top: 0 !important;
                > svg {
                    color: #d14124;
                    width: 25px;
                    height: 25px;
                }
            }
            &:hover {
                background: #d14124;
                svg {
                    color: #fff;
                }
            }
        `,
    },
    blogListWrapper: {
        css: css`
            width: 100%;
            position: relative;
            padding: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 5px;
                    `,
                    css`
                        padding: 5px;
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
    blogListWrapperContainer: {
        css: css`
            overflow: hidden;
            padding-top: 70px;
            width: 100%;
        `,
    },
    blogListWrapperWithCarousal: {
        css: css`
            display: flex;
            margin-left: -10px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css``,
                    css`
                        margin-right: 7px;
                    `,
                    css`
                        margin-right: 7px;
                    `,
                ])}
        `,
    },
    blogListWrapperWithoutCarousal: {
        css: css`
            display: flex;
            justify-content: center;
            width: 100%;
        `,
    },
    leftQuote: {
        css: css`
            margin-right: 5px;
            svg {
                width: 13px;
                fill: ${getColor("success.main")};
            }
        `,
    },
    rightQuote: {
        css: css`
            margin-left: 5px;
            svg {
                width: 13px;
                fill: #64a70b;
            }
        `,
    },
};
const MeetYourHerbsQuote: React.FC<Props> = ({ fields }) => {
    let isCarousal = false;
    if (typeof window !== "undefined") {
        if (window.screen.width > 1200 && fields.links.length > 2) {
            isCarousal = true;
        } else if (fields.links.length > 2 && window.screen.width < 1200 && window.screen.width > 767) {
            isCarousal = true;
        } else if (window.screen.width < 768 && fields.links.length > 1) {
            isCarousal = true;
        } else {
            isCarousal = false;
        }
    }

    const [emblaRef, embla] = useEmblaCarousel();
    const [, setCanScrollPrev] = React.useState(false);
    const [, setCanScrollNext] = React.useState(false);
    const setCanScroll = () => {
        setCanScrollPrev(!!embla && embla.canScrollPrev());
        setCanScrollNext(!!embla && embla.canScrollNext());
    };

    React.useEffect(() => {
        if (!embla) {
            return;
        }

        embla.on("init", setCanScroll);
        embla.on("select", setCanScroll);
        embla.reInit({
            slidesToScroll: 1,
            loop: true,
        });
        setCanScroll();
    }, [embla]);

    const scrollNext = React.useCallback(() => {
        if (!embla) {
            return;
        }

        embla.scrollNext();
    }, [embla]);

    return (
        <>
            <StyledWrapper {...styles.blogContainer}>
                {isCarousal && (
                    <StyledWrapper {...styles.prevArrowContainer}>
                        <Button {...styles.prevArrowButton} onClick={() => embla && embla.scrollPrev()}>
                            <ButtonIcon src={ChevronLeft} />
                        </Button>
                    </StyledWrapper>
                )}
                <StyledWrapper {...styles.blogListWrapper}>
                    <StyledWrapper {...styles.blogListWrapperContainer} ref={isCarousal ? emblaRef : null}>
                        <StyledWrapper
                            {...(isCarousal
                                ? { ...styles.blogListWrapperWithCarousal }
                                : { ...styles.blogListWrapperWithoutCarousal })}
                        >
                            {fields.links?.map((item, index) => (
                                <StyledWrapper
                                    {...(isCarousal
                                        ? { ...styles.blogCardWithCarausal }
                                        : { ...styles.blogCardWithoutCarausal })}
                                >
                                    <LazyImage
                                        src={item.fields.imageUrl}
                                        altText={item.fields.altText}
                                        {...styles.blogImage}
                                    />
                                    <StyledWrapper {...styles.blogDesc}>
                                        <Typography {...styles.leftQuote}>
                                            <LeftDoubleQuote />
                                        </Typography>
                                        {item.fields.description}
                                        <Typography {...styles.rightQuote}>
                                            <RightDoubleQuote />
                                        </Typography>
                                    </StyledWrapper>
                                    <Typography {...styles.blogTitle}> {item.fields.title}</Typography>
                                    <Typography {...styles.blogSubtitle}> {item.fields.subTitle}</Typography>
                                </StyledWrapper>
                            ))}
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
                {isCarousal && (
                    <StyledWrapper {...styles.nextArrowContainer}>
                        <Button {...styles.nextArrowButton} onClick={() => embla && embla.scrollNext()}>
                            <ButtonIcon src={ChevronRight} />
                        </Button>
                    </StyledWrapper>
                )}
            </StyledWrapper>
        </>
    );
};
const definition: WidgetDefinition = {
    group: "Basic",
    fieldDefinitions: [
        {
            name: fields.links,
            editorTemplate: "ListField",
            defaultValue: [],
            fieldType: "General",
            getDisplay: (item: HasFields) => {
                return item.fields.title;
            },
            fieldDefinitions: [
                {
                    name: "imageUrl",
                    editorTemplate: "ImagePickerField",
                    defaultValue: "",
                },
                {
                    name: "altText",
                    editorTemplate: "TextField",
                    defaultValue: "",
                },
                {
                    name: "description",
                    displayName: "Description",
                    editorTemplate: "MultilineTextField",
                    defaultValue: "",
                    isRequired: true,
                },
                {
                    name: "title",
                    displayName: "Title",
                    editorTemplate: "TextField",
                    defaultValue: "",
                    isRequired: true,
                },
                {
                    name: "subTitle",
                    displayName: "Subtitle",
                    editorTemplate: "TextField",
                    defaultValue: "",
                    isRequired: true,
                },
            ],
        },
    ],
};

const widgetModule: WidgetModule = {
    component: MeetYourHerbsQuote,
    definition,
};

export default widgetModule;
